import { is, List } from 'immutable';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Could not find a declaration file for module
import { fetchAccounts } from '../actions/AccountsActions';
// @ts-expect-error Could not find a declaration file for module
import { getAccountsProductsByPortal } from '../selectors/accountsSelectors';
export const useOwnedProducts = () => {
  const ownedProducts = useSelector(getAccountsProductsByPortal);
  const accountsNotFetched = useSelector(state => state.accounts.get('data') === null && !state.accounts.get('isRequesting') && !state.accounts.get('hasError'));
  const accountsRequesting = useSelector(state => state.accounts.get('isRequesting'));
  const dispatch = useDispatch();
  useEffect(() => {
    if (accountsNotFetched) {
      dispatch(fetchAccounts());
    }
  }, [accountsNotFetched, dispatch]);
  return [ownedProducts, accountsRequesting];
};
export const useIsPaidAccount = () => {
  const [ownedProducts, isRequesting] = useOwnedProducts();
  return [ownedProducts && !is(ownedProducts, List(['hubspot-free'])), isRequesting];
};